import React from 'react';
import useIsMobile from '../../shared/hooks/useIsMobile';
import PurposeMobile from './Purpose.mobile';
import PurposeDesktop from './Purpose.desktop';

const PurposeFeature = () => {
  const isMobile = useIsMobile();
  const View = isMobile ? PurposeMobile : PurposeDesktop;
  return <View />;
};

export default PurposeFeature;
